import { Link } from 'wouter';
import { Button, Logo } from '../components/primitives/index.js';

export function NotFound() {
  return (
    <div className="min-h-dvh bg-bg flex flex-col">
      <nav className="px-4 md:px-8 py-4 md:py-5 border-b border-line">
        <Logo />
      </nav>
      <main className="flex-1 flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <div className="text-6xl sm:text-7xl lg:text-display-1 font-medium text-fg leading-none mb-4">404</div>
        <p className="text-muted text-lg mb-8 max-w-md">
          Pagina pe care o cauți nu există sau a fost mutată.
        </p>
        <Link href="/">
          <Button pill>Înapoi la prima pagină</Button>
        </Link>
      </main>
    </div>
  );
}
